export function creatBasePageData () {
  return {
    page: 1,
    size: 30,
    total: 0
  }
}
